/**
 * @congress/auth-helper v1.0.0
 * @version 1.0.0
 * @license CYIM: www.cyim.com
 */

import AuthType from './AuthType.enum.js';
class CyimService {
  /**
   * Default constructor & use cyim token
   * @constructor CyimService
   * @deprecated
   */
  constructor() {
    this.type = AuthType.CYIM;
    this._token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6Ijg1MzI2M2EyLTQyNDItNDlmOC04NTJhLThjMTI1M2U3ZDA4NiIsInBlcm1pc3Npb25zIjpbInJlYWRBbGwiLCJ3cml0ZUFsbCJdLCJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkN5aW0iLCJpYXQiOjE1MTYyMzkwMjJ9.AxOYR_dzjD1SwPMpj5V3u7zHmkCY0nrWEOdsiLFXhz0";
    this._tokenParsed = this._decodeToken(this._token);
  }

  /**
   * Decode JWT Token
   * @param str
   * @returns {null | string}
   * @private
   */
  _decodeToken(str) {
    let token = null;
    try {
      if (str) {
        str = str.split(".")[1];
        str = str.replace(/-/g, "+");
        str = str.replace(/_/g, "/");
        switch (str.length % 4) {
          case 0:
            break;
          case 2:
            str += "==";
            break;
          case 3:
            str += "=";
            break;
          default:
            throw new Error("Invalid token");
        }
        str = decodeURIComponent(escape(window.atob(str)));
        token = JSON.parse(str);
      }
    } catch (err) {
      console.error("Failed to decode token:", err);
    }
    return token;
  }

  /**
   * Always true with CYIM account.
   * @returns {boolean}
   */
  isAuthenticated() {
    return true;
  }

  /**
   * CYIM token never expires
   * @returns {boolean}
   */
  isTokenExpired() {
    return false;
  }

  /**
   * The base64 encoded token that can be sent in the Authorization header in requests to services.
   * @returns {string|null|*}
   */
  getToken() {
    return this._token;
  }

  /**
   * The parsed token as a JavaScript object.
   * @returns {null|string|*}
   */
  getTokenParsed() {
    return this._tokenParsed;
  }
}
export { CyimService as default };
//# sourceMappingURL=CyimService.js.map
